<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="roles">
    <v-row class="d-md-flex align-center">
      <v-col
        ><h1>{{ $t("roles") }}</h1></v-col
      >
      <v-col cols="12" md="4" class="d-flex justify-end">
        <template>
          <v-dialog v-model="dialogRoles" max-width="600px" height="100%">
            <template v-slot:activator="{ on }">
              <v-btn
                class="btn-two mobile-block"
                height="56px"
                text
                v-on="on"
                @click.stop="openAddForm"
                :disabled="isDisabledAdd()"
              >
                <v-icon medium>mdi-plus</v-icon>
                {{ $t("role.create_role") }}
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline" v-if="itemId">{{
                  $t("role.edit_role")
                }}</span>
                <span class="headline" v-if="itemId === false">{{
                  $t("role.create_role")
                }}</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-autocomplete
                        ref="orgAuto"
                        v-model="setOrganization"
                        :items="orgItems"
                        :label="$t('role.organization_name_label')"
                        item-text="name"
                        item-value="id"
                        :loading="orgLoading"
                        :search-input.sync="orgSearch"
                        :filter="() => true"
                        clearable
                        @focus="onOrgOpen"
                        @click="onOrgOpen"
                        @update:search-input="onOrgSearchInput"
                        @click:clear="onOrgClear"
                        outlined
                        large
                        :error-messages="errorMessagesOrganizationField"
                        :no-data-text="$t('noDataAvailable')"
                      >
                        <template v-slot:item="data">
                          <div>
                            <div>
                              <b>{{ data.item.name }}</b>
                            </div>
                            <div>
                              <span v-if="data.item.street">{{
                                data.item.street
                              }}</span>
                              <span v-if="data.item.postalCode"
                                >, {{ data.item.postalCode }}</span
                              >
                              <span v-if="data.item.place"
                                >, {{ data.item.place }}</span
                              >
                              <span v-if="data.item.countryCode"
                                >, {{ data.item.countryCode }}</span
                              >
                            </div>
                          </div>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="nameFieldText"
                        :label="$t('role.role_name')"
                        outlined
                        clearable
                        :error-messages="errorMessagesNameField"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-tooltip
                        top
                        v-for="item in allPermissions"
                        :key="item.id"
                      >
                        <template v-slot:activator="{ on }">
                          <v-checkbox
                            v-model="selectedPermissions"
                            :value="item.id"
                            :label="item.name"
                            color="#5b8ff5"
                            v-on="on"
                            class="ma-0 pa-0"
                          ></v-checkbox>
                        </template>
                        <span>{{ item.description }}</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeAddForm">{{
                  $t("close")
                }}</v-btn>
                <v-btn color="blue darken-1" text @click="saveRole">{{
                  $t("save")
                }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
      </v-col>
      <v-col cols="12" md="1">
        <v-btn
          class="bg-white"
          color="#e3e9ed"
          height="56px"
          block
          text
          outlined
          @click="showSearchRow"
        >
          <v-icon color="#4f526c">mdi-magnify</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col col="12">
        <v-expand-transition>
          <v-row class="transition-display brd-top-vone" v-show="showSearch">
            <v-col cols="12" md="6" lg="8">
              <v-text-field
                :placeholder="$t('crm.search')"
                outlined
                hide-details
                v-model="searchText"
                background-color="#fff"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" lg="2">
              <v-btn
                height="56px"
                class="btn-one"
                block
                text
                depressed
                @click="hideFilter"
              >
                <span>{{ $t("cancel") }}</span>
              </v-btn>
            </v-col>
            <v-col cols="12" md="3" lg="2">
              <v-btn
                class="btn-two"
                color="#08a657"
                height="56px"
                block
                depressed
                dark
                @click="search"
              >
                <span>{{ $t("search") }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-expand-transition>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="rolesData"
            class="elevation-1"
            :options.sync="options"
            :items-per-page="options.rowsPerPageItems"
            :server-items-length="totalItems"
            :loading="this.$store.state.loading"
            :footer-props="{
              'items-per-page-options': this.$store.state.rowsPerPageItems,
              'items-per-page-text': $t('rowsPerPage'),
            }"
            :no-data-text="$t('noDataAvailable')"
          >
            <template v-slot:item.edit="{ item }">
              <v-btn
                fab
                small
                color="#fff"
                :disabled="isDisabledDeleteEdit(item)"
              >
                <v-icon color="#5b8ff5" @click="editItem(item)">
                  mdi-pencil-outline
                </v-icon>
              </v-btn>
            </template>
            <template v-slot:item.delete="{ item }">
              <v-btn
                fab
                small
                color="#fff"
                :disabled="isDisabledDeleteEdit(item)"
              >
                <v-icon color="#5b8ff5" @click="deleteItem(item)">
                  mdi-delete
                </v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="deleteDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">{{
          $t("role.delete_role")
        }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-alert type="warning">
            {{ $t("role.delete_warning_message") }}
          </v-alert>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="deleteDialog = false">
            {{ $t("cancel") }}
          </v-btn>

          <v-btn color="green darken-1" text @click="removeItem()">
            {{ $t("crm.delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.isShow" :timeout="3000">
      {{ snackbar.text }}
      <v-btn color="white" text @click="snackbar.isShow = false">
        {{ $t("close") }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { i18n } from "@/plugins/i18n";
import config from "../config";
import Axios from "axios";

export default {
  components: {},
  data() {
    return {
      options: {},
      payload: {
        Id: 0,
        name: "",
        organization: "",
        OrganizationsId: 0,
        roleCategory: 0,
        Search: "",
        Page: 1,
        Limit: 10,
        OrderBy: "Name",
        Direction: "asc",
      },
      showSearch: false,
      searchText: "",
      dialogRoles: false,
      itemId: false,
      nameFieldText: "",
      setOrganization: null,
      //roleCategoryType: 1,
      errorMessagesNameField: "",
      errorMessagesOrganizationField: "",
      roleId: 0,
      deleteDialog: false,
      roleCategoryType: [
        { value: 1, name: this.$i18n.t("role.system") },
        { value: 2, name: this.$i18n.t("role.custom") },
      ],
      setRoleCategoryType: null,
      errorMessagesRoleCategoryTypeField: "",
      roleCategoryTypeInputText: "",

      orgSearch: "",
      orgItems: [],
      orgTopItems: [],
      orgTopLoaded: false,
      orgMenuOpen: false,
      orgLoading: false,
      orgDebounceTimer: null,
      orgCache: Object.create(null),

      snackbar: {
        isShow: false,
        text: "",
      },
      allPermissions: [],
      selectedPermissions: [],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "",
          value: "edit",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: "",
          value: "delete",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: this.$i18n.t("role.name"),
          value: "name",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("role.organization_name"),
          value: "organizationName",
          width: "1%",
          align: "left",
        },
      ];
    },
    totalItems() {
      return this.$store.getters.ROLES_TOTAL;
    },
    rolesData() {
      let data = [];

      /* eslint-disable */
      this.$store.getters.ROLES_LIST.forEach(function(item, i) {
        data.push({
          id: item.id,
          name: item.name,
          organizationName: item.organizationName,
          organizationsId: item.organizationsId,
          roleCategory: item.roleCategory,
          permissions: item.permissions.split(", ").map((el) => {
            const num = parseInt(el);
            return Number.isNaN(num) ? el : num;
          }),
        });
      });
      return data;
    },
    lang() {
      return this.$store.state.language;
    },
  },
  created() {
    this.$vuetify.lang.current = i18n.locale;
    this.$store.state.roles = [];
    this.getPermissions();
  },
  methods: {
    ...mapActions(["GET_ROLES", "DELETE_ROLE", "EDIT_ROLE", "CREATE_ROLE"]),
    showSearchRow() {
      this.showSearch = true;
    },
    hideFilter() {
      this.showSearch = false;
      this.searchText = "";

      this.payload = this.payloadDefault();
      this.payload.Limit = this.options.itemsPerPage;
      this.GET_ROLES(this.payload);
    },
    search(e) {
      e.preventDefault();
      if (this.searchText.length > 0) {
        this.payload = this.payloadDefault();
        this.payload.Limit = this.options.itemsPerPage;
        this.payload.Search = this.searchText.trim();
        this.GET_ROLES(this.payload);
      }
    },
    payloadDefault() {
      return {
        Id: 0,
        name: "",
        organization: "",
        OrganizationsId: 0,
        roleCategory: 0,
        Search: "",
        Page: 1,
        Limit: 10,
        OrderBy: "Name",
        Direction: "asc",
      };
    },
    onOrgOpen() {
      this.orgMenuOpen = true;

      clearTimeout(this.orgDebounceTimer);

      const q = (this.orgSearch || "").trim();

      if (this.setOrganization && q.length >= 2) {
        this.fetchOrganizations(q).then(() => {
          this.$nextTick(() => this.scrollOrgMenuToActive());
        });
        return;
      }

      this.ensureTopOrganizationsLoaded().then(() => {
        this.$nextTick(() => this.scrollOrgMenuToActive());
      });
    },

    async editItem(item) {
      this.dialogRoles = true;
      this.itemId = true;
      this.nameFieldText = item.name;
      this.roleId = item.id;
      this.setRoleCategoryType = 2;

      this.setOrganization = item.organizationsId;

      const selected = {
        id: item.organizationsId,
        name: item.organizationName,
      };

      this.orgItems = [selected];
      this.orgSearch = (item.organizationName || "").trim();

      this.orgMenuOpen = false;

      this.selectedPermissions = item.permissions;
    },

    deleteItem(item) {
      this.deleteDialog = true;
      this.roleId = item.id;
    },
    removeItem() {
      this.DELETE_ROLE(this.roleId).then((response) => {
        if (response.status === 200) {
          this.snackbar.text = this.$i18n.t("role.deleted");
          this.snackbar.isShow = true;
        }
      });
      this.deleteDialog = false;
    },
    openAddForm() {
      this.itemId = false;
      this.nameFieldText = "";
      this.setOrganization = null;

      this.errorMessagesNameField = "";
      this.errorMessagesOrganizationField = "";
      this.selectedPermissions = [];

      this.orgSearch = "";
      this.orgItems = [];
      this.orgMenuOpen = false;
    },

    closeAddForm() {
      this.itemId = false;
      this.nameFieldText = "";
      this.setOrganization = null;
      this.setRoleCategoryType = "";

      this.errorMessagesNameField = "";
      this.errorMessagesOrganizationField = "";
      this.errorMessagesRoleCategoryTypeField = "";

      this.dialogRoles = false;
    },

    ensureTopOrganizationsLoaded() {
      if (this.orgTopLoaded) {
        this.orgItems = this.orgTopItems;
        return Promise.resolve();
      }

      this.orgLoading = true;

      return Axios.get(config.apiBaseUrl + "api/organization/box-list", {
        params: { search: "" },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      })
        .then((response) => {
          if (response.status === 200) {
            const items = response.data || [];
            this.orgTopItems = items;
            this.orgItems = items;
            this.orgTopLoaded = true;
            this.orgCache[""] = items;
          }
        })
        .catch((err) =>
          console.log("box-list error", err?.response?.status, err)
        )
        .finally(() => {
          this.orgLoading = false;
        });
    },

    fetchOrganizations(q) {
      if (this.orgCache[q]) {
        this.orgItems = this.orgCache[q];
        return Promise.resolve();
      }

      this.orgLoading = true;

      return Axios.get(config.apiBaseUrl + "api/organization/box-list", {
        params: { search: q },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      })
        .then((response) => {
          if (response.status === 200) {
            const items = response.data || [];
            this.orgItems = items;
            this.orgCache[q] = items;
          }
        })
        .catch((err) =>
          console.log("box-list error", err?.response?.status, err)
        )
        .finally(() => {
          this.orgLoading = false;
        });
    },

    onOrgClear() {
      this.setOrganization = null;
      this.orgSearch = "";

      clearTimeout(this.orgDebounceTimer);

      if (this.orgMenuOpen) {
        this.ensureTopOrganizationsLoaded();
      } else {
        this.orgItems = [];
      }
    },

    async onOrgMenu(isOpen) {
      this.orgMenuOpen = isOpen;
      if (!isOpen) return;

      await this.ensureTopOrganizationsLoaded();

      if (this.itemId && this.setOrganization && this.orgSearch) {
        const selected = { id: this.setOrganization, name: this.orgSearch };
        const exists = this.orgItems.some((x) => x.id === selected.id);
        if (!exists) this.orgItems = [selected, ...this.orgItems];
      }
    },

    onOrgSearchInput(val) {
      const q = (val || "").trim();

      clearTimeout(this.orgDebounceTimer);

      if (q.length === 0) {
        this.ensureTopOrganizationsLoaded().then(() => {
          this.$nextTick(() => this.scrollOrgMenuToActive());
        });
        return;
      }

      if (q.length < 2) {
        this.orgItems = this.orgTopItems;
        return;
      }

      this.orgDebounceTimer = setTimeout(() => {
        this.fetchOrganizations(q).then(() => {
          this.$nextTick(() => this.scrollOrgMenuToActive());
        });
      }, 300);
    },

    scrollOrgMenuToActive() {
      setTimeout(() => {
        const root = this.$refs.orgAuto && this.$refs.orgAuto.$el;
        if (!root) return;

        const menu = document.querySelector(
          ".v-menu__content.menuable__content__active"
        );
        if (!menu) return;

        const active = menu.querySelector(".v-list-item--active");
        if (!active) return;

        active.scrollIntoView({ block: "nearest" });
      }, 0);
    },

    saveRole(e) {
      if (e && e.preventDefault) e.preventDefault();

      let data = {};
      let errCounter = 0;

      this.errorMessagesNameField = "";
      this.errorMessagesOrganizationField = "";
      this.errorMessagesRoleCategoryTypeField = "";

      if (this.roleCategoryTypeInputText === null) {
        this.errorMessagesRoleCategoryTypeField = this.$i18n.t(
          "field_is_required"
        );
        errCounter++;
      }

      if (!this.nameFieldText || !this.nameFieldText.trim()) {
        this.errorMessagesNameField = this.$i18n.t("field_is_required");
        errCounter++;
      }

      if (!this.setOrganization) {
        this.errorMessagesOrganizationField = this.$i18n.t("field_is_required");
        errCounter++;
      }

      if (errCounter !== 0) return;

      data.Name = this.nameFieldText.trim();
      data.RoleCategory = 1;
      data.permissions = this.selectedPermissions.join(",");
      data.OrganizationsId = Number(this.setOrganization);

      if (this.itemId) {
        data.Id = this.roleId;

        this.EDIT_ROLE({ data, searchParams: this.payload }).then(
          (response) => {
            if (response.status === 200) {
              this.snackbar.text = this.$i18n.t("role.updated");
              this.snackbar.isShow = true;
            }
          }
        );
      } else {
        this.CREATE_ROLE(data).then((response) => {
          if (response.status === 200) {
            this.snackbar.text = this.$i18n.t("role.created");
            this.snackbar.isShow = true;
          }
        });
      }

      this.dialogRoles = false;
    },

    getPermissions() {
      Axios.get(config.apiBaseUrl + "api/role/permission-list", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then((response) => {
          if (response.status === 200) {
            this.allPermissions = response.data;
          }
        })
        .catch(function(error) {
          /* eslint-disable */
          console.log(error);
        });
    },

    isDisabledDeleteEdit(item) {
      if (!this.$isPermitted("modifyOrDeleteRoles")) return true;
      return item.roleCategory === 2;
    },
    isDisabledAdd() {
      return !this.$isPermitted("modifyOrDeleteRoles");
    },

    // end methods
  },
  watch: {
    options: {
      handler() {
        this.$store.state.loading = true;
        this.payload.Page = this.options.page;
        this.payload.Limit = this.options.itemsPerPage;

        let sortByLength = this.options.sortBy.length;
        let sortDescLength = this.options.sortDesc.length;

        if (sortByLength > 0) {
          this.payload.OrderBy = this.options.sortBy[0];
        }

        if (sortDescLength > 0) {
          if (this.options.sortDesc[0]) {
            this.payload.Direction = "desc";
          }
        } else {
          this.payload.Direction = "asc";
        }

        this.GET_ROLES(this.payload);
      },
      deep: true,
    },
    lang(v) {
      this.getPermissions();
    },
    setOrganization() {
      this.errorMessagesOrganizationField = "";
    },
    nameFieldText() {
      this.errorMessagesNameField = "";
    },

    setOrganization(val) {
      this.errorMessagesOrganizationField = "";

      if (!val) return;

      const id = Number(val);

      const found =
        this.orgItems.find((x) => Number(x.id) === id) ||
        this.orgTopItems.find((x) => Number(x.id) === id);

      if (found && found.name) {
        this.orgSearch = found.name;
      }
    },
  },
};
</script>
